import { usePermissionsChecker } from "core/auth/Permissions";
import { Permission } from "core/common-types/permission.enum";
import { FunctionComponent, ReactNode } from "react";

import { useBlocksClinicalStoreActions } from "@bps/blocks";
import {
  CenteredBox,
  FontIcon,
  FontSizes,
  Heading,
  Link,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { logout } from "@bps/msal";

interface LockedErrorBoxProps {
  heading: ReactNode;
  children: ReactNode;
  resolutionText: ReactNode;
}

export const LockedErrorBox: FunctionComponent<LockedErrorBoxProps> = ({
  heading,
  children,
  resolutionText
}) => {
  const theme = useTheme();

  const { resetSessionValues } = useBlocksClinicalStoreActions();

  const hasPermissions = usePermissionsChecker();
  const hasBpmWebAllowedPermission = hasPermissions(
    Permission.ProsBpmWebAllowed
  );

  const onLoginClick = async () => {
    hasBpmWebAllowedPermission && resetSessionValues();
    await logout();
  };
  return (
    <CenteredBox tokens={{ childrenGap: 10 }}>
      <Stack
        styles={{
          root: {
            width: "90px",
            height: "90px",
            backgroundColor: theme.palette.neutralTertiaryAlt,
            borderRadius: "62px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }}
      >
        <FontIcon
          iconName="Lock"
          styles={{
            root: { color: theme.palette.white, fontSize: FontSizes.size32 }
          }}
        />
      </Stack>
      <Heading variant="heading">{heading}</Heading>
      {children}
      <Text>
        {resolutionText}{" "}
        <Link onClick={onLoginClick}> log in as a different user.</Link>
      </Text>
    </CenteredBox>
  );
};
